<template>
  <div class="dormpage flexCloumnSingleCenter">
    <div class="form">
      <div class="cell-group-title flexStart">
        <span style="color: #1283FF">*</span>住校申请</div>
      <div class="cell-group">
        <van-field :readonly="disabled" v-model="editForm.class" label="班级" required placeholder="请输入班级"/>
        <van-field :readonly="disabled" v-model="editForm.stuName" label="姓名" required placeholder="请输入姓名"/>
        <van-field :readonly="disabled" class="childBox" name="checkbox" label="性别" required>
          <template #input>
            <van-radio-group :disabled="disabled" :readonly="disabled"
                             v-model="editForm.gender"
                             direction="horizontal">
              <van-radio name="1">男</van-radio>
              <van-radio name="2">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field :readonly="disabled" v-model="editForm.address" label="现居地址" required placeholder="请输入家庭地址"/>
        <div class="flexCloumn" style="width: 100%;">
          <div class="item-title flexStart item-title-required">申请住校简述</div>
          <div class="item-input">
            <el-input :disabled="disabled" v-model.trim="editForm.remark" type="textarea" placeholder="请输入内容……"
                      :autosize="{ minRows: 4, maxRows: 10 }" style="width: 100%"/>
          </div>
        </div>
      </div>

    </div>
    <div v-if="!disabled" class="submitBtn flexCenter">
      <div class="btn btnChange" @click="onSubmitForm">提交</div>
    </div>
    <div v-if="disabled" class="submitBtn flexCenter">
      <div class="btn" @click="onModify">点击修改</div>
    </div>
    <div style="width: 100%;height: 100px;"></div>

  </div>
</template>

<script>
import {
  Toast, Dialog
} from 'vant';
import wx from 'weixin-js-sdk'
export default {
  props: {
    // tableInfo: {
    //   type:Object,
    //   default:{}
    // },
    // stu_id: {
    //   type:Number,
    //   default:0,
    // },
    // pmid: {
    //   type:Number,
    //   default:5,
    // },
  },
  data() {
    return {
      editForm: {
        class:'',
        stuName: '',
        gender: '',
        address:'',
        remark:'',
      },
      openid: null,
      disabled: false,
      pmid:5,
      stu_id:0,
      tableInfo:{},

    }
  },
  mounted() {
    let _this = this
    $(".dormpage").height($(window).height())//设置页面高度固定，防止输入法弹出页面变形，注意内部元素不能使用vh
    if (this.$route.query) {
      console.log(79, this.$route.query)
      this.stu_id = Number(this.$route.query.stu_id)
      this.pmid = Number(this.$route.query.pmid)
      _this.getList(1)
    }

  },
  methods: {
    getStuInfo(){
      let _this = this
      return new Promise(resolve => {
        this.$http.post("/api/stu_luqu_detail", {
          stu_id: _this.stu_id,
          pmid: this.pmid
        }).then(res => {
          console.log(res.data)
          if(res.data){
            _this.editForm.department = res.data.yuanxi_name
            _this.editForm.major_name = res.data.major_name
            _this.editForm.class = res.data.class_name
            _this.editForm.stuName = res.data.stu_name
            _this.editForm.gender = String(res.data.gender)
            _this.editForm = {..._this.editForm}
            console.log(_this.editForm)
          }
          resolve()
        })
      })
    },

    getList(flag) {
      let _this = this
      return new Promise(resolve => {
        this.$http.post('/api/t_stu_check_in_table_list', {
          pmid: _this.pmid,
          stu_id: _this.stu_id
        }).then(res => {
          for (let item of res.data.data) {
            if (item.table_name.indexOf('住宿') != -1) {
              document.title = item.table_name
              _this.tableInfo = item
              if(flag == 1){
                if (item.table_detail) {
                  let detail = JSON.parse(item.table_detail)
                  _this.editForm = Object.assign(detail)
                  _this.disabled = true
                } else {
                  _this.getStuInfo()
                  _this.disabled = false
                }
              }
              console.log(_this.editForm)
              resolve()
              return;
            }
          }
          resolve()
        })
      })
    },

    onSubmitForm() {
      let _this = this

      if (!this.editForm.class) {
        Toast('班级不能为空！');
        return
      }
      if (!this.editForm.stuName) {
        Toast('姓名不能为空！');
        return
      }
      if (!this.editForm.gender) {
        Toast('性别不能为空！');
        return
      }
      if (!this.editForm.address ) {
        Toast('现居地不能为空！');
        return
      }
      if (!this.editForm.remark ) {
        Toast('申请住宿简述不能为空！');
        return
      }

      _this.getList(0).then(result=>{
        console.log(_this.tableInfo)
        let params = {}
        params.table_detail = JSON.stringify(_this.editForm)
        params.table_name = _this.tableInfo.table_name
        params.table_code = _this.tableInfo.table_code
        params.stu_id = this.stu_id
        params.table_type_id = _this.tableInfo.type_id
        params.pmid = this.pmid
        if(_this.tableInfo.id){
          params.id = _this.tableInfo.id
        }
        console.log(params)
        this.requestForm(params)
      })

    },
    requestForm(params) {
      let _this = this
      this.$http.post("/api/t_stu_check_in_table_edit", params).then(function (res) {
        if (res.data.id||res.data.message=='') {
          Toast('保存成功！')
          localStorage.removeItem('tableInfo')
          localStorage.removeItem('editForm')
          setTimeout(function (){
            _this.editForm = {}
            wx.miniProgram.navigateBack({
              delta: 1
            })
          },500)
          _this.preExport()
        } else {
          Toast(res.data.msg)
          _this.disabled = false
        }
      })

    },
    preExport() {
      let _this = this
      this.$http.post("/api/stu_luqu_detail", {
        stu_id: _this.stu_id,
        pmid: _this.pmid
      }).then(res => {
        console.log(res.data)
        if (res.data.class_id) {
          let params = {
            class_id: _this.editForm.class_id,
            stu_ids: _this.stu_id,
            pmid: _this.pmid,
          }
          _this.$http.post("/api/exportWord1", params).then(function (res) {})
        }

      })


    },

    onModify() {
      let curTime = new Date().getTime()
      let time1 = new Date(this.tableInfo.cdate).getTime()
      let val = curTime - time1
      this.getDuration(val).then(result => {
            console.log(result.d,result.h)
            if (result.d > 0 || result.h > 3) {
              this.disabled = false
            } else {
              Dialog.alert({
                title: "距上次提交时间小于3小时，请不要频繁修改。",
                showCancelButton: false,
                confirmButtonText: "确定",
                cancelButtonText: "关闭",
                confirmButtonColor: '#1283FF',
              }).then(() => {
                this.disabled = true
              }).catch(() => {
                console.log("点击了取消按钮噢")
              })
            }
          }
      )
      console.log(new Date(), this.tableInfo.cdate, this.tableInfo)
    },
    getDuration(my_time) {
      return new Promise(resolve => {
        var days = my_time / 1000 / 60 / 60 / 24;
        var daysRound = Math.floor(days);
        var hours = my_time / 1000 / 60 / 60 - (24 * daysRound);
        var hoursRound = Math.floor(hours);
        var minutes = my_time / 1000 / 60 - (24 * 60 * daysRound) - (60 * hoursRound);
        var minutesRound = Math.floor(minutes);
        var seconds = my_time / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound);
        console.log('转换时间:', daysRound + '天', hoursRound + '时', minutesRound + '分', seconds + '秒');
        var time = hoursRound + ':' + minutesRound + ':' + seconds
        let obj = {d:daysRound,h:hoursRound}
        resolve(obj)
        return time;
      })

    },
  },
}
</script>

<style lang="less" type="text/less">
.el-textarea__inner:focus {
  outline: 0;
  border-color: #1283FF !important;
}

.van-radio__icon {
  font-size: 16px;
}

.van-radio__icon--checked .van-icon {
  background-color: #1283FF;
  border-color: #1283FF;
}

.van-checkbox {
  margin-top: 10px;
}

.van-checkbox__icon {
  font-size: 16px;
}

.van-checkbox__icon--checked .van-icon {
  background-color: #1283FF;
  border-color: #1283FF;
}

.van-tag--primary {
  background-color: #1283FF;
}

.van-cell--required::before {
  color: #1283FF !important;
}

.dormpage {
  display: block;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background-color: #fff;

  .form {
    flex: 1;
    width: 100%;
    box-sizing: border-box;

    div {
      font-size: 14px;
      color: #323232;
      box-sizing: border-box;
    }

    .cell-group-title {
      padding: 10px 0 5px 15px;
      font-size: 14px;
      color: #969799;
      background-color: #f5f5f5;
    }

    .cell-group {
      padding: 0 20px;
      background-color: #fff;
    }

    .topInfo {
      color: #00D1CB;
      font-size: 12px;
    }

    .item-title {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 16px;
    }
    .item-title-required{position: relative;}
    .item-title-required::before {
      position: absolute;
      left: 8px;
      color: #1283FF;
      font-size: 14px;
      content: '*';
    }
    .item-input {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 0 16px 10px 16px;
      font-size: 14px;
      color: #646566;
    }

    .item-input1 {
      color: #ee0a24;
      font-size: 12px;
      line-height: 18px;
    }

    .item-input1::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 16px;
      bottom: 0;
      left: 16px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
    }
  }

  .submitBtn {
    padding-top: 6vh;
    width: 100%;

    .btn {
      display: inline-block;
      padding: 1.4vh 0;
      width: 60%;
      text-align: center;
      background-color: #1283FF;
      color: #fff;
      font-size: 15px;
      border-radius: 6px;
    }
  }
}

</style>
